import { useEffect } from "react";

function UseBootstrap() {
  useEffect(() => {
    // Add stuff before load
  }, []);
}

export default UseBootstrap;
